import React, { useState } from 'react'
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@material-ui/core'

export const ErrorModal = (props: any) => {
    const [errorDialog, setErrorDialog] = useState(true)
    const handleClose = () => {
        setErrorDialog(false)
    }

    return (
        <Dialog
            open={errorDialog}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Se encontraron errores al enviar el archivo.
            </DialogTitle>
            <DialogContent>
                <DialogContentText>Vea el detalle en el listado de registros que no se pudieron ingresar</DialogContentText>
            </DialogContent>
                {/* {errorMessage.map((err: ErrorSheet) => {
                    return (
                        <Typography key={err.row}>
                            &#8226; Fila {err.row}: {err.message}{' '}
                        </Typography>
                    )
                })} */}
            <DialogActions>
                <Button color="primary" onClick={handleClose}>
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export const SuccessModal = () => {
    const [successDialog, setSuccessDialog] = useState(true)
    const handleClose = () => {
        setSuccessDialog(false)
    }
    return (
        <Dialog
            open={successDialog}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Envío realizado con éxito
            </DialogTitle>
            <DialogActions>
                <Button color="primary" onClick={handleClose}>
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    )
}
